import * as algoliasearch from 'algoliasearch';
import { filterDocuments } from '../helper/filterDocuments';
import { ALGOLIA_APP_ID, ALGOLIA_ADMIN_KEY } from '../config/algoliaConfig';

const algoliaDataSearch = async ({value = '', type = "all"}) => {
   
    const client = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_ADMIN_KEY, {
        protocol: "https:"
    })

    let algoliaData = {};

    const indexUser = client.initIndex("users");
    const indexDocuments = client.initIndex("documents");
    const indexViruses = client.initIndex("available_viruses");

    if(type === "all") {
        await indexUser.search(value).then((data) => {
            let patients = data.hits;

            patients = patients.filter((patient) => patient.role === 'patient');

            const filterPatients = filterDocuments({documents: patients, search: value,type: 'fullName'});

            algoliaData.patients = filterPatients;
        });
    
        await indexDocuments.search(value).then((data) => {
            algoliaData.documents = data.hits
        });
    
        await indexViruses.search(value).then((data) => {
            const virus = filterDocuments({documents: data.hits, search: value,type: 'name'});

            algoliaData.virus = virus;
        });
    };

    if(type === 'patients') {
        await indexUser.search(value).then((data) => {
            let patients = data.hits;

            patients = patients.filter((patient) => patient.role === 'patient');

            const filterPatients = filterDocuments({documents: patients, search: value,type: 'fullName'});
            
            algoliaData.patients = filterPatients;
        });
    };

    return algoliaData;
};

export default algoliaDataSearch;
